enum DeviceModels {
  Unknown = "Unknown",
  OculusRift = "OculusRift",
  OculusRiftS = "OculusRiftS",
  OculusGo = "OculusGo",
  OculusQuest = "OculusQuest",
  OculusGearVR = "OculusGearVR",
  Vive = "Vive",
  VivePro = "VivePro",
  PicoNeo2 = "PicoNeo2",
  PicoNeo2Eye = "PicoNeo2Eye",
  Mobile = "Mobile",
  None = "None",
};

export default DeviceModels;